module.exports = __webpack_public_path__ + "img/adw_tc_img.80bf5c7c.png";